// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"93fa33c1","821":"a4afff1c","937":"34e43f03"}[chunkId] + ".chunk.js";
};